import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import './index.css';

import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import CandidateProfile from './pages/CandidateProfile';
import ApplicantPortal from './pages/ApplicantPortal';
import AdminMarkTest from './pages/AdminMarkTest';
import CandidateTest from './pages/CandidateTest';
import TestComplete from './pages/TestComplete';
import SignDocument from './pages/SignDocument';
import PopiaConsentConfirm from './pages/PopiaConsentConfirm';
import RetentionRenewalConfirm from './pages/RetentionRenewalConfirm';
import ContractRenewalDecision from './pages/ContractRenewalDecision';
import ArchivedCandidates from './pages/ArchivedCandidates';
import TeamMemberInfoForm from './pages/TeamMemberInfoForm';
import HowItWorks from './pages/HowItWorks';
import NewEmployee from './pages/NewEmployee';
import Scorecard from './pages/Scorecard';
import UserManagement from './pages/UserManagement';
import Login from './pages/Login';
import SsoLanding from './pages/SsoLanding';

function LoginPage() {
  const navigate = useNavigate();
  return <Login onLogin={() => navigate('/dashboard')} />;
}

// Wrapper to handle test query parameter at root
function RootRouter() {
  const [searchParams] = useSearchParams();
  const testToken = searchParams.get('test');

  if (testToken) {
    return <CandidateTest token={testToken} />;
  }

  return <Navigate to="/dashboard" />;
}

// Use /talentpool basename when deployed to production (detected via runtime-config)
const BASENAME = window.__RUNTIME_CONFIG__?.apiBase?.startsWith('/talentpool') ? '/talentpool' : '';

export default function App() {
  return (
    <BrowserRouter basename={BASENAME}>
     <Routes>
        {/* Query parameter test link */}
        <Route path="/" element={<RootRouter />} />

        {/* Candidate-facing (no nav) */}
        <Route path="/test/:candidateId" element={<CandidateTest />} />
        <Route path="/test-complete" element={<TestComplete />} />
        <Route path="/sign/:docType/:token" element={<SignDocument />} />
        <Route path="/popia-consent/:token" element={<PopiaConsentConfirm />} />
        <Route path="/retention-renewal/:token" element={<RetentionRenewalConfirm />} />
        <Route path="/contract-renewal/:token" element={<ContractRenewalDecision />} />

        {/* Applicant portal */}
        <Route path="/apply" element={<ApplicantPortal />} />
        <Route path="/portal/team-member-info" element={<TeamMemberInfoForm />} />
        <Route path="/portal/how-it-works" element={<HowItWorks />} />
        <Route path="/portal" element={<ApplicantPortal />} />
        <Route path="/portal/*" element={<ApplicantPortal />} />

        {/* Admin login */}
        <Route path="/login" element={<LoginPage />} />
        {/* Single sign-on from the Spectacles dashboard portal */}
        <Route path="/sso" element={<SsoLanding />} />

        {/* Admin / staff routes — wrapped in shared layout */}
        <Route path="/" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="candidate/:id" element={<CandidateProfile />} />
          <Route path="candidate/:id/mark-test" element={<AdminMarkTest />} />
          <Route path="applications" element={<NewEmployee />} />
          <Route path="scorecard" element={<Scorecard />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="archived-candidates" element={<ArchivedCandidates />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}
